import React from 'react';
import './index.css'; // Make sure to create this CSS file in your project.
import {useNavigate} from 'react-router-dom';
import {configArrDto, features} from "../../common/config";
import {useTranslation} from "react-i18next";


const Feature = ({title, description, imgSrc, id}: {
  title: string;
  description?: string;
  imgSrc: string;
  id: string | number;
}) => {
  let navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <div className="feature" onClick={() => {
      navigate(`/feature-detail/${id}`); // 使用navigate函数跳转到指定路由
    }}>
      <img src={imgSrc} alt={title} className="feature-image"/>
      <h3 className="feature-title">{t(title)}</h3>
      {/*<p className="feature-description">{description}</p>*/}
    </div>
  )
};

const FeatureModule = () => {
  const { t } = useTranslation();
  return (
    <section className="feature-section">
      <h2 className="section-title">{t('systemFeature')}</h2>
      <div className="feature-module">
        {features.map((feature, index) => (
          <Feature
            key={index}
            title={feature.title}
            description={feature.description}
            imgSrc={feature.imgSrc}
            id={feature?.id}
          />
        ))}
      </div>
    </section>
  )
};

export default FeatureModule;
